import { render, staticRenderFns } from "./CommandComp.vue?vue&type=template&id=68e0e027&scoped=true&"
import script from "./CommandComp.vue?vue&type=script&lang=js&"
export * from "./CommandComp.vue?vue&type=script&lang=js&"
import style0 from "./CommandComp.vue?vue&type=style&index=0&id=68e0e027&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e0e027",
  null
  
)

export default component.exports